import { EuiIcon } from "@inscopix/ideas-eui";
import { ColorsByTaskStatus } from "types/ColorsByTaskStatus";
import { TaskStatus } from "types/constants";
import { useModalContext } from "providers/ModalProvider/ModalProvider";
import { Task } from "graphql/_Types";
import { ModalTaskLogs } from "components/ButtonViewTaskLogs/ModalTaskLogs";
import { includes } from "lodash";
import { DATA_TABLE_TOOLTIP_ID } from "pages/gdt/layout/DataTableTooltip";

interface TaskStatusAndLogIconProps {
  taskId: Task["id"];
  taskStatus: TaskStatus;
  taskCreated: Task["dateCreated"];
}

export const TaskStatusIcon = ({
  taskId,
  taskStatus,
  taskCreated,
}: TaskStatusAndLogIconProps) => {
  const color = ColorsByTaskStatus[taskStatus];
  const taskStatusName = TaskStatus[taskStatus];
  const showTaskLog = includes(
    [TaskStatus["COMPLETE"], TaskStatus["ERROR"], TaskStatus["FAILED"]],
    taskStatus,
  );
  const { openModal, closeModal } = useModalContext();

  const showModal = () =>
    openModal(
      <ModalTaskLogs
        task={{ id: taskId, status: taskStatus, dateCreated: taskCreated }}
        onClose={closeModal}
      />,
    );

  const tooltipHtml = `<span style="color:${color}">${taskStatusName}</span>${
    showTaskLog ? `<br />View task logs` : ""
  }`;

  return (
    <EuiIcon
      data-tooltip-id={DATA_TABLE_TOOLTIP_ID}
      data-tooltip-html={tooltipHtml}
      data-test-id={`task-status-icon-${TaskStatus[taskStatus]}`}
      aria-label="View task logs"
      type="stopFilled"
      size="l"
      color={color}
      onClick={() => showTaskLog && showModal()}
      style={{ cursor: showTaskLog ? "pointer" : "default" }}
    />
  );
};
